import apiClient from './client'

// NOTA: rimossi i metodi che puntavano a rotte inesistenti o disallineate rispetto a
// CustomersApiController (search via POST, uploadDocument su {id}/documents, privacy
// consents su {id}/privacy, tags - mai implementati backend-side). Le pagine reali
// (CustomerDetails, CustomerPrivacy, DocumentsTab) chiamano apiClient direttamente con i
// path corretti; questo modulo espone solo le operazioni verificate ed effettivamente
// usate altrove (vedi EmailsPage.tsx per getAll).
export const customersApi = {
  getAll: (params?: Record<string, unknown>) =>
    apiClient.get('/customers', { params }).then((r) => r.data),
  getById: (id: string) =>
    apiClient.get(`/customers/${id}`).then((r) => r.data),
  create: (data: Record<string, unknown>) =>
    apiClient.post('/customers', data).then((r) => r.data),
  update: (id: string, data: Record<string, unknown>) =>
    apiClient.put(`/customers/${id}`, data).then((r) => r.data),
  delete: (id: string) =>
    apiClient.delete(`/customers/${id}`),

  getProperties: (id: string) =>
    apiClient.get(`/customers/${id}/properties`).then((r) => r.data),
  getRequests: (id: string) =>
    apiClient.get(`/customers/${id}/requests`).then((r) => r.data),
  getDocuments: (id: string) =>
    apiClient.get(`/customers/${id}/documents`).then((r) => r.data),
  getPrivacyConsents: (id: string) =>
    apiClient.get(`/customers/${id}/privacy-consents`).then((r) => r.data),
  addPrivacyConsent: (id: string, consent: Record<string, unknown>) =>
    apiClient.post(`/customers/${id}/privacy-consents`, consent),
  exportData: (id: string) =>
    apiClient.post(`/customers/${id}/export-data`).then((r) => r.data),
  getRelationships: (id: string) =>
    apiClient.get(`/customers/${id}/relationships`).then((r) => r.data),
  addRelationship: (id: string, relationship: Record<string, unknown>) =>
    apiClient.post(`/customers/${id}/relationships`, relationship),
  removeRelationship: (id: string, relationshipId: string) =>
    apiClient.delete(`/customers/${id}/relationships/${relationshipId}`),
  getStatistics: (id: string) =>
    apiClient.get(`/customers/${id}/statistics`).then((r) => r.data),
}
